/* eslint-disable no-undef */
import { isEmpty, isPlainObject } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';
import 'select2';

class SelectCore extends Component {
  state = {
    results: this.props.results || [],
  };

  // LIFECYCLE

  componentDidMount() {
    const { onChange, onBlur } = this.props;

    $(this.select)
      .select2(this.select2Options())
      .on('select2:select select2:unselect', onChange)
      .on('select2:close', onBlur);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ results }) {
    if (results && results.length > 0) {
      this.setState({
        results,
      });
    }
  }

  shouldComponentUpdate() {
    const { allowUpdate } = this.props;

    return !!allowUpdate;
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate() {
    $(this.select).select2('destroy');
  }

  componentDidUpdate() {
    $(this.select).select2(this.select2Options());
  }

  componentWillUnmount() {
    // eslint-disable-next-line jquery/no-data
    $(this.select).data('select2') && $(this.select).select2('destroy');
  }

  // LOGIC

  select2Options = () => {
    const { remoteUrl, placeholder } = this.props;
    // eslint-disable-next-line jquery/no-closest
    const $dialog = $(this.select).closest('dialog');
    const options = {
      ...($dialog.length ? { dropdownParent: $dialog } : {}),
      minimumResultsForSearch: this.props.minimumResultsForSearch,
      placeholder:
        placeholder || (this.defaultPlaceholder && this.defaultPlaceholder()),
      width: '100%',
    };

    if (remoteUrl) {
      options.ajax = {
        url: remoteUrl,
        dataType: 'json',
        processResults: (data) => {
          const results = { results: [] };

          // eslint-disable-next-line jquery/no-each
          $.each(data, (i, val) => {
            results.results.push({
              id: val.id,
              text: val.title || val.name,
            });
          });

          return results;
        },
      };
    }

    return options;
  };

  // RENDERERS

  renderOptions = () => {
    const { blankValue, results } = this.props;

    const data = isEmpty(results) ? [...this.state.results] : [...results];

    if (data && data.length) {
      const options = data.map((result) => {
        if (!isPlainObject(result)) {
          result = { id: result, text: result };
        }

        return (
          <option key={result.id} value={result.id}>
            {result.name || result.text || result.title}
          </option>
        );
      });

      if (blankValue) {
        options.unshift(<option key="default" value="" />);
      }

      return options;
    }
  };

  render() {
    const {
      id,
      multiple,
      name,
      value,
      defaultValue,
      className,
      tooltip,
      disabled,
      onChange,
    } = this.props;
    let chosenDefaultValue;

    // Accept all kinds of value
    if (
      value ||
      typeof value === 'boolean' ||
      typeof value === 'number' ||
      (value && value.length)
    ) {
      chosenDefaultValue = value;
    } else if (defaultValue) {
      chosenDefaultValue = defaultValue;
    } else if (multiple) {
      chosenDefaultValue = [];
    } else {
      chosenDefaultValue = '';
    }

    return (
      <select
        id={id}
        name={name}
        style={{ width: '100%' }}
        multiple={multiple}
        defaultValue={chosenDefaultValue}
        ref={(r) => (this.select = r)}
        title={tooltip}
        data-toggle={tooltip && 'tooltip'}
        className={className}
        disabled={disabled}
        onChange={onChange}
        data-testid="select-core"
      >
        {this.renderOptions()}
      </select>
    );
  }
}

SelectCore.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  allowUpdate: PropTypes.bool,
  multiple: PropTypes.bool,
  results: PropTypes.array,
  blankValue: PropTypes.bool,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  remoteUrl: PropTypes.string,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  minimumResultsForSearch: PropTypes.number,
};

SelectCore.defaultProps = {
  allowUpdate: true,
  multiple: true,
  results: [],
  blankValue: false,
};

export default SelectCore;
